import PageSwitch from '../../components/common/PageSwitch';
import { SupplierUploadHistory, DataUpload } from '../barratt';

/**
 * Monthly Files — who has sent their monthly Supplier Performance and Quality
 * files (and chasing those who have not), and the customer's own Invoice file.
 */
export default function MonthlyFilesPage() {
  return (
    <PageSwitch
      testId="monthly-files-tabs"
      tabs={[
        { value: 'suppliers', label: "Suppliers' files", element: <SupplierUploadHistory /> },
        { value: 'invoice', label: 'Invoice file', element: <DataUpload /> },
      ]}
    />
  );
}
